// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type EnterprisePermittedProductsAccessType = 'WHITELIST' | 'BLACKLIST';

export interface EnterprisePermittedProductsV1 {
  id: string;
  productIds: Array<string>;
  accessType: EnterprisePermittedProductsAccessType;
  clientScopes: Array<string>;
  privateCourseIds: Array<string>;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface EnterprisePermittedProductsV1Connection {
  elements: Array<EnterprisePermittedProductsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface EnterprisePermittedProductsV1GetQuery {
  EnterprisePermittedProductsV1: {
    get: EnterprisePermittedProductsV1Connection | null;
  } | null;
}

export interface EnterprisePermittedProductsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class EnterprisePermittedProductsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'enterprisePermittedProducts.v1' as const;

  declare id: string;

  declare productIds: Array<string>;

  declare accessType: EnterprisePermittedProductsAccessType;

  declare clientScopes: Array<string>;

  declare privateCourseIds: Array<string>;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<EnterprisePermittedProductsV1>) {
    super(params);
  }
}
